<template>
  <div class="cs" :class="{
    'cs-active': isActive,
    'cs-top': addressGray && !singleChannel,
    'cs-noTab-top': addressGray && singleChannel,
    'cs-noTab': !addressGray && singleChannel,
    }" id="cs">
    <Category
      :path="path"
      :category="category"
      :isActive="isActive"
      @handlerActive="onActive"
      @handlerUpdata="onUpdata"
      @handlerClear="onClear"
      v-if="category && category.length && showContent"
    ></Category>
    <Searches
      :pageIndex="defParams.pageIndex"
      :searches="searches"
      :path="path"
      :updating="updating"
      v-if="searches.length && showContent"
      @handlerUpdata="onUpdata"
    ></Searches>
    <LoadEnd v-if="loadEnd"></LoadEnd>
    <LoadError v-if="loadError && defParams.pageIndex !== 1"></LoadError>
    <loadStart v-if="fetching && defParams.pageIndex !== 1"></loadStart>
    <listSkeleton v-if="fetching && defParams.pageIndex == 1 && !searches.length" :needLoading="true" />
    <MaskLayer
      v-show="isActive"
      :isActive="isActive"
      @handlerActive="onActive"
    ></MaskLayer>
    <Nothing
      :addressGray="addressGray"
      :path="path"
      v-if="isEmpty && !fetching"
      :tabs="tabs"
      @handlerUpdata="onUpdata"
    ></Nothing>
    <to-top />
  </div>
</template>

<script>
import { mapState } from "vuex";
import mixin from "../mixin";
import Category from "../components/Category";
import Searches from "../components/Searches";
import MaskLayer from "../components/MaskLayer";
import LoadStart from "../components/LoadStart";
import LoadEnd from "../components/loadEnd";
import LoadError from "../components/loadError";
import Nothing from "../components/Nothing";
import ToTop from "../components/ToTop";
import listSkeleton from "../components/GoodsListSkeleton";
export default {
  name: window.curPath,
  mixins: [mixin],
  data() {
    return {
      showContent: true,
      path: window.curPath,
      name: this.constant.newEntityInfo[window.curPath]
    };
  },
  computed: {
    category() {
      const pathName = JSON.parse(JSON.stringify(this.path));
      return JSON.parse(JSON.stringify(this.$store.state[pathName].category));
    },
    searches() {
      const pathName = JSON.parse(JSON.stringify(this.path));
      return JSON.parse(JSON.stringify(this.$store.state[pathName].searches));
    },
    fetching() {
      const pathName = JSON.parse(JSON.stringify(this.path));
      return JSON.parse(JSON.stringify(this.$store.state[pathName].fetching));
    },
    loadEnd() {
      const pathName = JSON.parse(JSON.stringify(this.path));
      return JSON.parse(JSON.stringify(this.$store.state[pathName].loadEnd));
    },
    loadError() {
      const pathName = JSON.parse(JSON.stringify(this.path));
      return JSON.parse(JSON.stringify(this.$store.state[pathName].loadError));
    },
    ...mapState({
      tabsLoading: state => state.tabsLoading,
      tabs: state => state.tabs,
      addressGray: state => state.addressGray,
      singleChannel: state => state.singleChannel,
    })
  },
  components: {
    Category,
    Searches,
    MaskLayer,
    LoadStart,
    LoadEnd,
    LoadError,
    Nothing,
    ToTop,
    listSkeleton,
  },
  watch: {
    $route: {
      handler: function(val, oldVal) {
        // 路由变化，接口数据重新获取
        if (val.name != oldVal.name && this.constant.newEntityPath.includes(val.name)) {
          // this.$router.go(0);
          this.path = val.name;
          this.showContent = false;
          const _this = this;
          this.onActive(false);
          this.getHeadV3({
            productTypes: this.constant.newEntityInfo[val.name]
          })
          this.onUpdata(
            { productTypes: this.constant.newEntityInfo[val.name] },
            1,
            true,
            () => {
              _this.showContent = true;
            }
          );
        }
      },
      deep: true
    }
  }
};
</script>
